export default __webpack_public_path__ + "static/media/Polvo-mascote.d28a84bd.png";